import DataCollection from "./DataCollection";

export default DataCollection;
